import React, { createContext, useContext, useEffect } from 'react';
import { useLocalStorage } from 'react-use';
const InactivityContext = createContext({});
export const LAST_ACTION_TIMESTAMP = 'lastActionTimestamp';
const InactivityProvider = (props) => {
    const [lastActionTimestamp, setLastActionTimestamp] = useLocalStorage(LAST_ACTION_TIMESTAMP);
    const resetLastActionTimestamp = () => {
        setLastActionTimestamp(JSON.stringify(Date.now()));
    };
    useEffect(() => {
        document.body.addEventListener('click', resetLastActionTimestamp);
        resetLastActionTimestamp();
        return () => {
            document.body.removeEventListener('click', resetLastActionTimestamp);
        };
    }, []);
    return React.createElement(InactivityContext.Provider, Object.assign({ value: { lastActionTimestamp } }, props));
};
const useInactivity = () => {
    const ctx = useContext(InactivityContext);
    if (ctx === undefined) {
        throw new Error('InactivityContext only works inside of an InactivityContext.Provider');
    }
    return ctx;
};
export { InactivityProvider, useInactivity };
